import React from 'react';

import Icon, { Props } from './icon';

export const PadlockIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="15 11 42 42">
      <path
        d="M16 18C16 14.6863 18.6863 12 22 12H50C53.3137 12 56 14.6863 56 18V46C56 49.3137 53.3137 52 50 52H22C18.6863 52 16 49.3137 16 46V18Z"
        fill="#F2F2F2"
        shapeRendering="crispEdges"
      />
      <path
        d="M36.0002 32C37.2152 32 38.2007 32.9855 38.2007 34.2005C38.2005 34.9133 37.8592 35.5447 37.3335 35.9466V38.7864C37.3335 39.5228 36.7365 40.1197 36.0002 40.1197C35.2638 40.1197 34.6668 39.5228 34.6668 38.7864V35.9466C34.1411 35.5447 33.7998 34.9133 33.7996 34.2005C33.7996 32.9855 34.7851 32 36.0002 32Z"
        fill="#011224"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0002 18.6666C39.6819 18.6666 42.6668 21.6516 42.6668 25.3333V26.6666H44.9338C45.8908 26.6668 46.6667 27.4426 46.6668 28.3997V43.6002C46.6667 44.5573 45.8908 45.3332 44.9338 45.3333H27.0666C26.1095 45.3332 25.3336 44.5573 25.3335 43.6002V28.3997C25.3336 27.4426 26.1095 26.6668 27.0666 26.6666H29.3335V25.3333C29.3335 21.6516 32.3184 18.6666 36.0002 18.6666ZM28.0002 42.6666H44.0002V29.3333H28.0002V42.6666ZM36.0002 21.3333C33.7912 21.3333 32.0002 23.1243 32.0002 25.3333V26.6666H40.0002V25.3333C40.0002 23.1243 38.2091 21.3333 36.0002 21.3333Z"
        fill="#011224"
      />
    </Icon>
  );
};

export default React.memo(PadlockIcon);
